/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} AcidityInputs */

const en_acidity = /** @type {(inputs: AcidityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acidity`)
};

const es_acidity = /** @type {(inputs: AcidityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acidez`)
};

/**
* | output |
* | --- |
* | "Acidity" |
*
* @param {AcidityInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const acidity = /** @type {((inputs?: AcidityInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<AcidityInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_acidity(inputs)
	return es_acidity(inputs)
});